import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OnboardingFlowControllerPage } from './onboarding-flow-controller.page';

const routes: Routes = [
  {
    path: 'webflow',
    component: OnboardingFlowControllerPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OnboardingFlowControllerPageRoutingModule {}
